<template>
  <div class="field">
    <label class="checkbox">
      <input v-model="acceptedTerms" type="checkbox" name="terms">
      <i class="fa fa-check"/>
      {{ $t('auth.Iaccept') }}
      <strong><a href="#" @click.prevent.stop="showTOS">{{ $t('auth.termsAndContidions') }}</a></strong>
    </label>
    <ErrorMessage v-if="!acceptedTerms">
      {{ $t('errors.acceptTerms') }}
    </ErrorMessage>
    <modal-component ref="modal" :title="$t('navigation.privacyPolicyAndTerms')">
      <div v-html="termsAndConditions.content"/>
    </modal-component>
  </div>
</template>
<script setup lang="ts">
import ErrorMessage from "~/components/ErrorMessage.vue";
import {ref} from 'vue'
import api from "~/api";
import type {TermAndConditionPublicOutput} from "~/api/generated";

const acceptedTerms = ref(false)
const modal = ref(null)
const termsAndConditions = ref<TermAndConditionPublicOutput>({})
const language = useI18n()

defineExpose({
  acceptedTerms: acceptedTerms,
  termsAndConditions: termsAndConditions
})

onMounted(async ()=>{
  const apiResponse = await api.TermsAndConditions.getTermAndConditionByLanguage(language.locale.value)
  termsAndConditions.value = apiResponse.data
})

function showTOS() {
  modal.value.openModal()
}
</script>